<template lang="pug">
  .width-100.container.m-top-1(v-if='contentCompleteness.resources')
    .field.row.middle.pointer(v-for='field in resourceRequiredFieldsList')
      checkbox.m-right-05(circle :checked='getCompletedField(resourceCompleteness, field)')
      h2.text-normal.prevent-select(@click='scrollTo(field, "presentation")')
        | {{ $t(`krea.progressBar.resourceMenu.${field}`) }}
    .field.row.middle.pointer(@click='setActiveDropdown("presentation")')
      checkbox.m-right-05(circle :checked='isPresentationCompleted')
      h2.text-normal.prevent-select {{ $t("krea.progressBar.resourceMenu.presentation") }}
      simple-svg.dropdown-icon.dark-gray-icon.m-top-05.m-left-05(
        :class='{active: activeDropdown === "presentation"}'
        :filepath='dropdownIcon'
        width='18px'
        height='18px'
      )
    .sub(v-show='activeDropdown === "presentation"')
      .field.inner.row.middle.pointer(v-for='field in resourcePresentationRequiredFieldsList')
        checkbox.m-right-05(circle :checked='getCompletedField(resourceCompleteness, field)')
        h2.text-normal.prevent-select(@click='scrollTo(field, "presentation")')
          | {{ $t(`krea.progressBar.resourcePresentationSubMenu.${field}`) }}
    .field.row.middle.pointer(@click='setActiveDropdown("teacher")')
      checkbox.m-right-05(circle :checked='isTeacherCompleted')
      h2.text-normal.prevent-select {{ $t("krea.progressBar.resourceMenu.teacher") }}
      simple-svg.dropdown-icon.dark-gray-icon.m-top-05.m-left-05(
        :class='{active: activeDropdown === "teacher"}'
        :filepath='dropdownIcon'
        width='18px'
        height='18px'
      )
    .sub(v-show='activeDropdown === "teacher"')
      .field.inner.row.middle.pointer(v-for='field in resourceTeacherRequiredFieldsList')
        checkbox.m-right-05(circle :checked='getCompletedField(resourceCompleteness, field)')
        h2.text-normal.prevent-select(@click='scrollTo(field, "teacher")')
          | {{ $t(`krea.progressBar.resourceTeacherSubMenu.${field}`) }}
      resource-class-menu(
        v-if='resourceCompleteness.classPlans.length'
        v-for='resClass in resourceCompleteness.classPlans.map(resClass => resClass).sort((a,b) => a.classNumber - b.classNumber)'
        type='teacher'
        :ref='"resourceClassMenu" + resClass.classPlanId'
        @clickedField='() => $emit("clickedField")'
        :isActive='activeClass === resClass.classNumber'
        @toggleClassMenu='setActiveClass'
        :key='resClass.classPlanId'
        :classNumber='resClass.classNumber'
        :resourceId='resourceId'
        :resourceCompleteness='resourceCompleteness'
      )
      .field.inner.row.middle.pointer(v-if='!resourceCompleteness.classPlans.length')
        router-link.add-class.row.middle(:to='{name: routes.kreaResourceTeacher, params: {id: resourceId}}')
          simple-svg.icon.white-icon.m-right-05(:filepath='addIcon' width='10px' height='10px')
          h2.text-normal {{ $t('krea.resource.sidebar.createClass') }}
    .field.row.middle.pointer(@click='setActiveDropdown("student")')
      checkbox.m-right-05(circle :checked='isStudentCompleted')
      h2.text-normal.prevent-select {{ $t("krea.progressBar.resourceMenu.student") }}
      simple-svg.dropdown-icon.dark-gray-icon.m-top-05.m-left-05(
        :class='{active: activeDropdown === "student"}'
        :filepath='dropdownIcon'
        width='18px'
        height='18px'
      )
    .sub(v-show='activeDropdown === "student"')
      .field.inner.row.middle.pointer(v-for='field in resourceStudentRequiredFieldsList')
        checkbox.m-right-05(circle :checked='getCompletedField(resourceCompleteness, field)')
        h2.text-normal.prevent-select(@click='scrollTo(field, "student")')
          | {{ $t(`krea.progressBar.resourceStudentSubMenu.${field}`) }}
      resource-class-menu(
        v-if='resourceCompleteness.classPlans.length'
        v-for='resClass in resourceCompleteness.classPlans.map(resClass => resClass).sort((a,b) => a.classNumber - b.classNumber)'
        type='student'
        :ref='"resourceClassMenu" + resClass.classPlanId'
        @clickedField='() => $emit("clickedField")'
        :isActive='activeClass === resClass.classNumber'
        @toggleClassMenu='setActiveClass'
        :key='resClass.classPlanId'
        :classNumber='resClass.classNumber'
        :resourceId='resourceId'
        :resourceCompleteness='resourceCompleteness'
      )
      .field.inner.row.middle.pointer(v-if='!resourceCompleteness.classPlans.length')
        router-link.add-class.row.middle(:to='{name: routes.kreaResourceStudent, params: {id: resourceId}}')
          simple-svg.icon.white-icon.m-right-05(:filepath='addIcon' width='10px' height='10px')
          h2.text-normal {{ $t('krea.resource.sidebar.createClass') }}
</template>

<script>
import {
  resourcePresentationRequiredFieldsList,
  resourceTeacherRequiredFieldsList,
  resourceStudentRequiredFieldsList,
  resourceRequiredFieldsList,
  getResourceCompletedClasses,
  resourceFieldsRoutes,
  getCompletedField
} from '../../../../constants/kreaResource'
import Checkbox from '@/components/Inputs/Checkbox'
import addIcon from '@/assets/ic_add.svg'
import dropdownIcon from '@/assets/ic_chevron-down.svg'
import { mapState } from 'vuex'
import ResourceClassMenu from './ResourceClassMenu'
import { routes } from '../../../../router'

export default {
  components: { Checkbox, ResourceClassMenu },
  props: {
    resourceId: { type: Number }
  },
  data() {
    return {
      dropdownIcon,
      addIcon,
      routes,
      activeDropdown: null,
      resourceRequiredFieldsList,
      resourcePresentationRequiredFieldsList,
      resourceTeacherRequiredFieldsList,
      resourceStudentRequiredFieldsList,
      getCompletedField,
      activeClass: null
    }
  },
  computed: {
    ...mapState({
      contentCompleteness: state => state.kreaEducationalContent.contentCompleteness
    }),
    resourceCompleteness() {
      return this.contentCompleteness.resources.find(res => res.resourceId === this.resourceId)
    },
    isPresentationCompleted() {
      return resourcePresentationRequiredFieldsList.filter(field =>
        getCompletedField(this.resourceCompleteness, field)
      ).length === resourcePresentationRequiredFieldsList.length
    },
    isTeacherCompleted() {
      return resourceTeacherRequiredFieldsList.filter(field =>
        getCompletedField(this.resourceCompleteness, field)
      ).length === resourceTeacherRequiredFieldsList.length &&
      getResourceCompletedClasses(this.resourceCompleteness, 'teacher').length === this.resourceCompleteness.classPlans.length
    },
    isStudentCompleted() {
      return resourceStudentRequiredFieldsList.filter(field =>
        getCompletedField(this.resourceCompleteness, field)
      ).length === resourceStudentRequiredFieldsList.length &&
      getResourceCompletedClasses(this.resourceCompleteness, 'student').length === this.resourceCompleteness.classPlans.length
    }
  },
  methods: {
    classCompleteness(classNumber) {
      return this.resourceCompleteness.classPlans.find(resClass => resClass.classNumber === classNumber)
    },
    setActiveClass(classNumber) {
      this.activeClass = classNumber
    },
    setActiveDropdown(item) {
      if (item === this.activeDropdown) {
        this.activeDropdown = null
      } else {
        this.activeDropdown = item
      }
    },
    hideResourceClassMenu(classPlanId) {
      this.$refs['resourceClassMenu' + classPlanId][0].hide()
    },
    scrollTo(field, tab) {
      this.$emit('clickedField')
      if (
        this.$route.name === resourceFieldsRoutes[field] &&
        Number(this.$route.params.id) === this.resourceId
      ) {
        this.redirectToField(field)
      } else {
        this.$router.push({
          name: resourceFieldsRoutes[field],
          params: { id: this.resourceId, fieldRedirection: field }
        })
      }
    },
    redirectToField(field) {
      const element = document.getElementById(field)
      const navbarOffset = 90
      const progressBarOffset = 90
      const elementPosition = element.getBoundingClientRect().top
      const offsetPosition = elementPosition + window.scrollY - (navbarOffset + progressBarOffset)

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      })
      element.classList.add('highlight')
      setTimeout(() => {
        element.classList.remove('highlight')
      }, 1500)
    }
  }
}
</script>

<style lang="scss" scoped>
@import 'src/scss/variables/colors.scss';

.container{
  width: 250px;
  background-color: $white;
  border-radius: 5px;
}

.add-class{
  .icon{
    padding: 3px;
    background-color: $blue;
    border-radius: 50%;
  }
}

.field{
  padding: 5px 8px;
  &:not(:last-child){
    border-bottom: 1px solid $light-gray;
  }
  &.inner{
    padding-left: 25px;
    border-bottom: 1px solid $light-gray;
  }
}

.dropdown-icon{
  transition: transform .5s ease;
  &.active{
    transform: rotate(180deg);
  }
}
</style>
